module.exports = __webpack_public_path__ + "img/login.fc730547.jpg";